export function shouldFilterWorkoutSetsByDate({ readOnly, setDateFilter }) {
  return Boolean(setDateFilter) && !readOnly;
}

export function shouldShowWorkoutHistory({ isOngoing, readOnly, readOnlySelected = false }) {
  return Boolean(isOngoing || (readOnly && readOnlySelected));
}
